// dimensiones prioritarias
const CN = 'Ciencias y Naturaleza';
const FM = 'Fabricación y Mecánica';
const CD = 'Ciencia de Datos';
const AP = 'Administración y Proyectos';
const AL = 'Artes y Literatura';
const SE = 'Soporte Social y Educación';
const IP = 'Influencia y Personas';
const LM = 'Liderazgo y Management';

const CN_Short = 'Ciencias y Naturaleza';
const FM_Short = 'Fabricación y Mecánica';
const CD_Short = 'Ciencia de Datos';
const AP_Short = 'Administración y Proyectos';
const AL_Short = 'Artes y Literatura';
const SE_Short = 'Sop. Social y Ed.';
const IP_Short = 'Influencia y Personas';
const LM_Short = 'Liderazgo y Management';

// areas de conocimiento
const A_AC = 'Administración y Comercio';
const A_AG = 'Agropecuaria';
const A_AR = 'Arte y Arquitectura';
const A_CN = 'Ciencias Exactas y Naturales';
const A_CS = 'Ciencias Sociales';
const A_D = 'Derecho';
const A_E = 'Educación';
const A_H = 'Humanidades';
const A_S = 'Salud';
const A_T = 'Tecnología';

// areas de conocimiento
const A_AC_Short = 'Administ. y Comercio';
const A_AG_Short = 'Agropecuaria';
const A_AR_Short = 'Arte y Arquitectura';
const A_CN_Short = 'Ciencias Exact. y Naturales';
const A_CS_Short = 'Ciencias Sociales';
const A_D_Short = 'Derecho';
const A_E_Short = 'Educación';
const A_H_Short = 'Humanidades';
const A_S_Short = 'Salud';
const A_T_Short = 'Tecnología';

export const colors = ['#ffffb2', '#fecc5c', '#fd8d3c', '#f03b20', '#bd0026'];
export const dimColors = [
  '#f6eff7',
  '#bdc9e1',
  '#67a9cf',
  '#1c9099',
  '#016c59'
];
// https://github.com/d3/d3-scale-chromatic/blob/master/src/diverging/RdYlGn.js
export const polarColors = [
  '#d7191c',
  '#fdae61',
  '#ffffbf',
  '#a6d96a',
  '#1a9641'
];

export const getDimensionFullName = dim => {
  let name = '';
  switch (dim) {
    case 'CN':
      name = CN;
      break;
    case 'FM':
      name = FM;
      break;
    case 'CD':
      name = CD;
      break;
    case 'AP':
      name = AP;
      break;
    case 'AL':
      name = AL;
      break;
    case 'SE':
      name = SE;
      break;
    case 'IP':
      name = IP;
      break;
    case 'LM':
      name = LM;
      break;
    default:
      name = CN;
      break;
  }
  return name;
};

export const getDimensionShortName = dim => {
  let name = '';
  switch (dim) {
    case 'CN':
      name = CN_Short;
      break;
    case 'FM':
      name = FM_Short;
      break;
    case 'CD':
      name = CD_Short;
      break;
    case 'AP':
      name = AP_Short;
      break;
    case 'AL':
      name = AL_Short;
      break;
    case 'SE':
      name = SE_Short;
      break;
    case 'IP':
      name = IP_Short;
      break;
    case 'LM':
      name = LM_Short;
      break;
    default:
      name = CN_Short;
      break;
  }
  return name;
};

export const getAreaFullName = area => {
  let name = '';
  switch (area) {
    case 'AC':
      name = A_AC;
      break;
    case 'AG':
      name = A_AG;
      break;
    case 'AR':
      name = A_AR;
      break;
    case 'CN':
      name = A_CN;
      break;
    case 'CS':
      name = A_CS;
      break;
    case 'D':
      name = A_D;
      break;
    case 'E':
      name = A_E;
      break;
    case 'H':
      name = A_H;
      break;
    case 'S':
      name = A_S;
      break;
    case 'T':
      name = A_T;
      break;
    default:
      name = A_AC;
      break;
  }
  return name;
};

export const getAreaShortName = area => {
  let name = '';
  switch (area) {
    case 'AC':
      name = A_AC_Short;
      break;
    case 'AG':
      name = A_AG_Short;
      break;
    case 'AR':
      name = A_AR_Short;
      break;
    case 'CN':
      name = A_CN_Short;
      break;
    case 'CS':
      name = A_CS_Short;
      break;
    case 'D':
      name = A_D_Short;
      break;
    case 'E':
      name = A_E_Short;
      break;
    case 'H':
      name = A_H_Short;
      break;
    case 'S':
      name = A_S_Short;
      break;
    case 'T':
      name = A_T_Short;
      break;
    default:
      name = A_AC_Short;
      break;
  }
  return name;
};

export const getAreaCareers = area => {
  let careers = [];
  switch (area) {
    case 'AC':
      careers = carrerasAdministracionYComercio;
      break;
    case 'AG':
      careers = carrerasAgropecuaria;
      break;
    case 'AR':
      careers = carrerasArteYArquitectura;
      break;
    case 'CN':
      careers = carrerasCienciasExactasYNaturales;
      break;
    case 'CS':
      careers = carrerasCienciasSociales;
      break;
    case 'D':
      careers = carrerasDerecho;
      break;
    case 'E':
      careers = carrerasEducacion;
      break;
    case 'H':
      careers = carrerasHumanidades;
      break;
    case 'S':
      careers = carrerasSalud;
      break;
    case 'T':
      careers = carrerasTecnologia;
      break;
    default:
      careers = [];
      break;
  }
  return careers;
};

export const getCareersTable = area => {
  let careers = [];
  switch (area) {
    case 'AC':
      careers = tableAdministracionYComercio;
      break;
    case 'AG':
      careers = tableAgropecuaria;
      break;
    case 'AR':
      careers = tableArteYArquitectura;
      break;
    case 'CN':
      careers = tableCienciasExactasYNaturales;
      break;
    case 'CS':
      careers = tableCienciasSociales;
      break;
    case 'D':
      careers = tableDerecho;
      break;
    case 'E':
      careers = tableEducacion;
      break;
    case 'H':
      careers = tableHumanidades;
      break;
    case 'S':
      careers = tableSalud;
      break;
    case 'T':
      careers = tableTecnologia;
      break;
    default:
      careers = [];
      break;
  }
  return careers;
};

const carrerasAgropecuaria = [
  {
    title:
      'Pesca y Piscicultura (Peces y Fauna Marina, Recursos Marinos, Biología Marina, Acuicultura)'
  },
  { title: 'Agronomía y Agricultura' },
  { title: 'Forestal (maderas, Bosques, Silvicultura)' },
  { title: 'Ciencias Pecuarias (Producción Animal, zootecnia y Ganadería)' },
  { title: 'Ciencias Veterinarias' },
  {
    title:
      'Ciencias del Suelo (Fruticultura, Viticultura, Horticultura y Producción Vegetal)'
  }
];

const carrerasArteYArquitectura = [
  {
    title:
      'Bellas Artes (Dibujo, Pintura, Escultura, Joyería, Comics, Ilustración, Estética)'
  },
  { title: 'Arquitectura y Urbanismo (Paisajismo, dibujo Arquitectónico)' },
  { title: 'Artes Escénicas (Arte Dramático, Danza, Escenografía Teatral)' },
  {
    title:
      'Diseño (Vestuario, Muebles, Gráfico, Interior y Decoración, Publicitario, Jardines, Ambientes, Etc.)'
  },
  {
    title:
      'Comunicación Audiovisual y de Medios (Artes Visuales, Cien, Televisión, fotografía, Multimedia)'
  },
  { title: 'Música (Interpretación, Instrumentista, Composición)' }
];

const carrerasCienciasExactasYNaturales = [
  {
    title:
      'Biología general (Biología, Zoología, Microbiología, Celular o Molecular)'
  },
  {
    title:
      'Ciencias de la vida (Ciencias en General, Botánica, Biología Humana, Fisiología Humana)'
  },
  { title: 'Química y Bioquímica' },
  { title: 'Física General Atómica o Nuclear' },
  { title: 'Matemática (Probabilidad, Análisis Numérico, Geometría)' },
  { title: 'Geología y Mineralogía (Geodesia, Geofísica)' },
  { title: 'Oceanografía' },
  { title: 'Ecología (Climatología, Meteorología, Ciencias de la Atmósfera)' },
  {
    title: 'Ciencias Especiales (Astronomía, Ciencias del Espacio, Cosmología'
  },
  { title: 'Astronomía' }
];

const carrerasCienciasSociales = [
  { title: 'Periodismo' },
  {
    title:
      'Ciencias Políticas y Administrativas   (Administración Pública, Políticas Públicas, Evaluación de Proyectos,   Relaciones Internacionales, Gobierno y Gerencia Pública, Gestión Pública)'
  },
  { title: 'Ciencias Económicas (Ingeniería   Comercial, Economía)' },
  { title: 'Trabajo Social (consejería Familiar,   Orientación Familiar)' },
  { title: 'Sociología' },
  {
    title:
      'Psicología (del Niño   y del Adolescente, Asesoramiento y Orientación Psicológica, Psicología   Industria, Personalidad)'
  },
  {
    title:
      'Antropología (Género, Cultura, Antropología Sociocultural, Asentamientos Humano, Arqueología)'
  },
  {
    title:
      'Comunicación Social y Dirección (Comunicación Organizacional, Corporativa, Persuasiva)'
  },
  { title: 'Relaciones Públicas' },
  { title: 'Publicidad' },
  { title: 'Historia y Geografía (cartografía)' },
  { title: 'Ciencias Sociales' }
];

const carrerasDerecho = [
  { title: 'Derecho' },
  { title: 'Apoyo Jurídico' },
  { title: 'Especialización Jurídica' }
];

const carrerasHumanidades = [
  { title: 'Filosofía' },
  { title: 'Lenguas Extranjeras (Traducción e Interpretación)' },
  { title: 'Ciencias Religiosas (Teología)' },
  { title: 'Literatura y Bibliotecología (Lingüística, Letras)' },
  { title: 'Ética' },
  { title: 'Humanidades' }
];

const carrerasEducacion = [
  { title: 'Ed. Parvularia' },
  { title: 'Ed. Básica y Rural' },
  { title: 'Ed. Media' },
  { title: 'Ed. Diferencial' },
  { title: 'Psicopedagogía' },
  {
    title:
      'Organización Educacional (Planificación de la Educación, Consejería)'
  },
  { title: 'Pedagogía Técnico Profesional' },
  { title: 'Deportes y Recreación' },
  { title: 'Ciencias de la Educación' }
];

const carrerasTecnologia = [
  { title: 'Ingeniería Civil (puras y con mención)' },
  { title: 'Obras civiles y Construcción (Hormigones, Estructura)' },
  {
    title:
      'Industria y Procesos Industriales (Civil, Automatización, Control Industrial, Control de Calidad, Dibujo Técnico, Diseño Industrial y Técnico, Textil, Celulosa y Papel, Matricería, Madrera, Agroindustria)'
  },
  { title: 'Prevención de Riesgos' },
  { title: 'Electricidad y Electrónica (Civil, Instalaciones)' },
  { title: 'Sonido y Acústica' },
  { title: 'Metalurgia y Minas (Civil, Procesos Mineros, Recursos Mineros)' },
  {
    title:
      'Química y bioquímica (Civil, Analista Químico, Químico Laboratorista, Química Industrial)'
  },
  {
    title:
      'Mecánica (Vehículos, Maquinaria Pesada, Oleo hidráulica, Neumática, Naval)'
  },
  { title: 'Geomensura, Topografía y Geología' },
  { title: 'Biotecnología y Bioprocesos' },
  {
    title:
      'Transporte y telecomunicaciones (Aviación Comercial, Transporte Marítimo Portuaria)'
  },
  {
    title:
      'Computación e Informática (Gestión Informática, Software, Redes y Conectividad)'
  },
  {
    title:
      'Climatización e Instalaciones (Gas, Instalaciones Sanitarias, Calefacción, Refrigeración)'
  },
  {
    title: 'Procesamiento y Tecnología de Alimentos (Conservación de Alimentos)'
  },
  { title: 'Ciencias de la Ingeniería' },
  { title: 'Ciencias del Medio Ambiente' },
  { title: 'Estadísticas y Matemáticas' }
];

const carrerasSalud = [
  { title: 'Medicina' },
  { title: 'Enfermería' },
  { title: 'Odontología' },
  { title: 'Química y Farmacia' },
  { title: 'Fonoaudiología' },
  { title: 'Kinesiología' },
  { title: 'Nutrición y Dietética' },
  { title: 'Obstetricia y Puericultura' },
  { title: 'Tecnología Médica' }
];

const carrerasAdministracionYComercio = [
  { title: 'Contabilidad (Gestión Tributaria y Computarizada)' },
  { title: 'Actividad Turística (Turismo, Hotelería, Gastronomía)' },
  {
    title:
      'Administración Financiera y Bancaria (Comercio, Relaciones Comerciales Internacionales, comercio Electrónico)'
  },
  {
    title:
      'Administración de Empresas (Ventas y Marketing, de Personal, Gestión de Empresas, Logística, Recursos Humanos)'
  },
  { title: 'Secretariado' },
  { title: 'Agropecuaria (Administración de Agronegocios)' }
];

const tableAdministracionYComercio = [
  { title: 'Administración Gastronómica', UNI: false, IP: true, CFT: false },
  {
    title: 'Administración Hotelera y Turística',
    UNI: true,
    IP: true,
    CFT: false
  },
  { title: 'Administración pública', UNI: true, IP: true, CFT: false },
  { title: 'Bachillerato en Administración', UNI: true, IP: false, CFT: false },
  { title: 'Contabilidad y Auditoría', UNI: true, IP: true, CFT: false },
  {
    title: 'Gastronomía y Cocina Internacional',
    UNI: true,
    IP: true,
    CFT: false
  },
  { title: 'Ingeniería Comercial', UNI: true, IP: false, CFT: false },
  {
    title: 'Ingeniería Comercial Plan Común',
    UNI: true,
    IP: false,
    CFT: false
  },
  {
    title: 'Ingeniería en Administración de Recursos Humanos',
    UNI: true,
    IP: true,
    CFT: false
  },
  {
    title: 'Ingeniería en Administración y Administración de Empresas',
    UNI: true,
    IP: true,
    CFT: false
  },
  {
    title: 'Ingeniería en Comercio Internacional',
    UNI: true,
    IP: true,
    CFT: false
  },
  {
    title: 'Ingeniería en Control de Gestión',
    UNI: true,
    IP: true,
    CFT: false
  },
  { title: 'Ingeniería en Finanzas', UNI: false, IP: true, CFT: false },
  { title: 'Ingeniería en Marketing', UNI: true, IP: true, CFT: false },
  {
    title: 'Ingeniería en Turismo y Hotelería',
    UNI: true,
    IP: true,
    CFT: false
  },
  { title: 'Publicidad', UNI: true, IP: true, CFT: false },
  {
    title: 'Técnico en Administración de Empresas',
    UNI: true,
    IP: true,
    CFT: true
  },
  {
    title: 'Técnico en Administración de Recursos Humanos',
    UNI: true,
    IP: true,
    CFT: true
  },
  {
    title: 'Técnico en Administración Pública',
    UNI: true,
    IP: true,
    CFT: true
  },
  { title: 'Técnico en Comercio Exterior', UNI: true, IP: true, CFT: true },
  {
    title: 'Técnico en Contabilidad y Auditoría',
    UNI: true,
    IP: true,
    CFT: true
  },
  { title: 'Técnico en Finanzas', UNI: true, IP: true, CFT: true },
  { title: 'Técnico en Gastronomía y Cocina', UNI: true, IP: true, CFT: true },
  { title: 'Técnico en Marketing', UNI: true, IP: true, CFT: true },
  { title: 'Técnico en Publicidad', UNI: false, IP: true, CFT: false },
  {
    title: 'Técnico en Secretariado y Asistente ejecutivo',
    UNI: true,
    IP: false,
    CFT: true
  },
  { title: 'Técnico en Turismo y Hotelería', UNI: true, IP: true, CFT: true },
  { title: 'Técnico en Ventas', UNI: false, IP: true, CFT: false }
];

const tableAgropecuaria = [
  { title: 'Agronomía', UNI: true, IP: false, CFT: false },
  { title: 'Biología Marina', UNI: true, IP: false, CFT: false },
  {
    title: 'Ingeniería Agrícola y Agropecuaría',
    UNI: true,
    IP: true,
    CFT: false
  },
  { title: 'Ingeniería Agroindustrial', UNI: true, IP: false, CFT: false },
  { title: 'Ingeniería Agronómica', UNI: true, IP: true, CFT: false },
  {
    title: 'Ingeniería Civil en Industrias de la Madera',
    UNI: true,
    IP: false,
    CFT: false
  },
  { title: 'Ingeniería Civil Oceánica', UNI: true, IP: false, CFT: false },
  { title: 'Ingeniería en Acuicultura', UNI: true, IP: false, CFT: false },
  { title: 'Ingeniería Forestal', UNI: true, IP: false, CFT: false },
  { title: 'Medicina Veterinaria', UNI: true, IP: false, CFT: false },
  { title: 'Oceanografía', UNI: true, IP: false, CFT: false },
  { title: 'Técnico Agropecuario', UNI: true, IP: true, CFT: true },
  { title: 'Técnico en Acuicultura', UNI: true, IP: false, CFT: true },
  { title: 'Técnico en Madera', UNI: false, IP: true, CFT: false },
  { title: 'Técnico en Veterinaria', UNI: true, IP: true, CFT: true },
  { title: 'Técnico en Vitivinicultura', UNI: true, IP: false, CFT: true }
];

const tableArteYArquitectura = [
  { title: 'Actuación', UNI: true, IP: true, CFT: false },
  { title: 'Animación digital', UNI: true, IP: true, CFT: false },
  { title: 'Arquitectura', UNI: true, IP: false, CFT: false },
  { title: 'Arte', UNI: true, IP: false, CFT: false },
  { title: 'Cine y Televisión', UNI: true, IP: true, CFT: false },
  {
    title: 'Composición e interpretación musical',
    UNI: true,
    IP: true,
    CFT: false
  },
  {
    title: 'Comunicación Audiovisual y Digital',
    UNI: true,
    IP: true,
    CFT: false
  },
  { title: 'Danza', UNI: true, IP: true, CFT: false },
  { title: 'Dibujante Proyectista', UNI: true, IP: false, CFT: false },
  { title: 'Diseño', UNI: true, IP: true, CFT: false },
  { title: 'Diseño de Interiores y Diseño de Vestuario', UNI: true, IP: true, CFT: false },
  // { title: 'Diseño de Vestuario', UNI: true, IP: true, CFT: false },
  { title: 'Diseño Escénico', UNI: true, IP: false, CFT: false },
  { title: 'Diseño Gráfico y Diseño Web', UNI: true, IP: true, CFT: false },
  { title: 'Diseño Industrial', UNI: true, IP: true, CFT: false },
  { title: 'Fotografía Profesional', UNI: false, IP: true, CFT: false },
  { title: 'Ilustración', UNI: false, IP: true, CFT: false },
  {
    title: 'Música y Licenciatura en música',
    UNI: true,
    IP: false,
    CFT: false
  },
  { title: 'Paisajismo', UNI: true, IP: false, CFT: false },
  { title: 'Producción Musical', UNI: true, IP: true, CFT: false },
  { title: 'Técnico en Animación digital', UNI: false, IP: true, CFT: true },
  { title: 'Técnico en Artes', UNI: false, IP: true, CFT: false },
  {
    title: 'Técnico en Comunicación Audiovisual',
    UNI: false,
    IP: true,
    CFT: true
  },
  {
    title: 'Técnico en Dibujo Arquitectónico y Dibujo Técnico',
    UNI: true,
    IP: true,
    CFT: true
  },
  { title: 'Técnico en Diseño Ambientes', UNI: false, IP: true, CFT: false },
  // { title: 'Técnico en Diseño de Vestuario', UNI: false, IP: true, CFT: true },
  {
    title: 'Técnico en Diseño Gráfico y Técnico en Diseño de Vestuario',
    UNI: false,
    IP: true,
    CFT: true
  },
  { title: 'Técnico en Diseño Industrial', UNI: false, IP: true, CFT: false },
  // { title: 'Técnico en Diseño Web', UNI: false, IP: true, CFT: true },
  {
    title: 'Técnico en Diseño e Ilustración y Técnico en Diseño Web',
    UNI: false,
    IP: true,
    CFT: true
  },
  { title: 'Técnico en Fotografía', UNI: false, IP: false, CFT: true },
  { title: 'Técnico en Música', UNI: false, IP: true, CFT: false },
  { title: 'Técnico en Paisajismo', UNI: false, IP: false, CFT: true },
  { title: 'Técnico en Restauración', UNI: false, IP: true, CFT: false }
];

const tableCienciasExactasYNaturales = [
  { title: 'Bachillerato en Ciencias', UNI: true, IP: false, CFT: false },
  { title: 'Biología', UNI: true, IP: false, CFT: false },
  { title: 'Bioquímica', UNI: true, IP: false, CFT: false },
  { title: 'Física y Astronomía', UNI: true, IP: false, CFT: false },
  { title: 'Geología', UNI: true, IP: false, CFT: false },
  { title: 'Ingeniería Civil en Física', UNI: true, IP: false, CFT: false },
  {
    title: 'Ingeniería Estadística y Estadística',
    UNI: true,
    IP: true,
    CFT: false
  },
  { title: 'Licenciatura en Ciencias', UNI: true, IP: false, CFT: false },
  { title: 'Licenciatura en Matemáticas', UNI: true, IP: false, CFT: false },
  { title: 'Química y carreras similares', UNI: true, IP: false, CFT: false },
  {
    title: 'Técnico en Química y Análisis Químico',
    UNI: true,
    IP: true,
    CFT: true
  }
];

const tableCienciasSociales = [
  { title: 'Antropología y Arqueología', UNI: true, IP: false, CFT: false },
  {
    title: 'Bachillerato en Ciencias Sociales',
    UNI: true,
    IP: false,
    CFT: false
  },
  { title: 'Bibliotecología', UNI: true, IP: false, CFT: false },
  { title: 'Ciencias Políticas', UNI: true, IP: false, CFT: false },
  {
    title: 'Comunicación Social y Empresarial',
    UNI: false,
    IP: true,
    CFT: false
  },
  {
    title: 'Orientación y mediación familiar',
    UNI: true,
    IP: false,
    CFT: false
  },
  { title: 'Periodismo', UNI: true, IP: false, CFT: false },
  { title: 'Producción de Eventos', UNI: false, IP: true, CFT: false },
  { title: 'Psicología', UNI: true, IP: false, CFT: false },
  { title: 'Relaciones Públicas', UNI: true, IP: true, CFT: false },
  { title: 'Sociología', UNI: true, IP: false, CFT: false },
  { title: 'Técnico en Bibliotecología', UNI: false, IP: true, CFT: true },
  {
    title: 'Técnico en Comunicaciones y Relaciones Públicas',
    UNI: false,
    IP: true,
    CFT: false
  },
  {
    title: 'Técnico en Dirección y Producción de Eventos',
    UNI: true,
    IP: true,
    CFT: false
  },
  {
    title: 'Técnico en Mediación, Prevención y Rehabilitación',
    UNI: true,
    IP: true,
    CFT: true
  },
  { title: 'Técnico en Trabajo Social', UNI: true, IP: true, CFT: true },
  {
    title: 'Trabajo Social, Servicio Social y Planificación Social',
    UNI: true,
    IP: true,
    CFT: false
  }
];

const tableDerecho = [
  { title: 'Bachillerato en Derecho', UNI: true, IP: false, CFT: false },
  { title: 'Derecho', UNI: true, IP: false, CFT: false },
  { title: 'Técnico Asistente Jurídico', UNI: false, IP: true, CFT: true },
  { title: 'Técnico en Criminalista', UNI: false, IP: true, CFT: false }
];

const tableEducacion = [
  { title: 'Educación Diferencial', UNI: true, IP: false, CFT: false },
  { title: 'Educación Parvularia', UNI: true, IP: true, CFT: false },
  { title: 'Entrenador Profesional', UNI: true, IP: true, CFT: false },
  { title: 'Pedagogía Básica y menciones', UNI: true, IP: false, CFT: false },
  { title: 'Pedagogía en Artes', UNI: true, IP: false, CFT: false },
  {
    title: 'Pedagogía en Biología y Química',
    UNI: true,
    IP: false,
    CFT: false
  },
  { title: 'Pedagogía en Castellano', UNI: true, IP: false, CFT: false },
  { title: 'Pedagogía en Educación Física', UNI: true, IP: false, CFT: false },
  {
    title: 'Pedagogía en Educación Técnico Profesional',
    UNI: true,
    IP: false,
    CFT: false
  },
  { title: 'Pedagogía en Filosofía', UNI: true, IP: false, CFT: false },
  { title: 'Pedagogía en Física', UNI: true, IP: false, CFT: false },
  {
    title: 'Pedagogía en Historia y Geografía',
    UNI: true,
    IP: false,
    CFT: false
  },
  { title: 'Pedagogía en Inglés', UNI: true, IP: false, CFT: false },
  { title: 'Pedagogía en Matemáticas', UNI: true, IP: false, CFT: false },
  { title: 'Pedagogía en Música', UNI: true, IP: false, CFT: false },
  { title: 'Pedagogía en Religión', UNI: true, IP: false, CFT: false },
  {
    title: 'Pedagogía y Licenciatura en Educación',
    UNI: true,
    IP: true,
    CFT: false
  },
  {
    title: 'Pedagogías para licenciados y/o programas especiales',
    UNI: true,
    IP: false,
    CFT: false
  },
  { title: 'Psicopedagogía', UNI: true, IP: true, CFT: false },
  { title: 'Técnico Educacional', UNI: true, IP: true, CFT: true },
  {
    title: 'Técnico en Deportes, Preparación Física y Recreación',
    UNI: true,
    IP: true,
    CFT: true
  },
  {
    title: 'Técnico en Educación Especial y/o Diferencial',
    UNI: true,
    IP: true,
    CFT: true
  },
  { title: 'Técnico en Educación Parvularia', UNI: true, IP: true, CFT: true }
];

const tableHumanidades = [
  { title: 'Bachillerato en Humanidades', UNI: true, IP: false, CFT: false },
  { title: 'Filosofía', UNI: true, IP: false, CFT: false },
  { title: 'Geografía', UNI: true, IP: false, CFT: false },
  { title: 'Historia', UNI: true, IP: false, CFT: false },
  { title: 'Historia y Geografía', UNI: true, IP: false, CFT: false },
  { title: 'Licenciatura en Estética', UNI: true, IP: false, CFT: false },
  { title: 'Literatura y/o letras', UNI: true, IP: false, CFT: false },
  {
    title: 'Técnico en Traducción e Interpretación',
    UNI: true,
    IP: true,
    CFT: true
  },
  { title: 'Teología', UNI: true, IP: false, CFT: false },
  { title: 'Traducción e Intérprete', UNI: true, IP: true, CFT: false }
];

const tableSalud = [
  {
    title: 'Bachillerato en Ciencias de la Salud',
    UNI: true,
    IP: false,
    CFT: false
  },
  { title: 'Enfermería', UNI: true, IP: false, CFT: false },
  { title: 'Estética Profesional', UNI: false, IP: true, CFT: false },
  { title: 'Fonoaudiología', UNI: true, IP: true, CFT: false },
  { title: 'Kinesiología', UNI: true, IP: true, CFT: false },
  { title: 'Medicina', UNI: true, IP: false, CFT: false },
  { title: 'Medicinas Alternativas', UNI: true, IP: true, CFT: false },
  { title: 'Nutrición y Dietética', UNI: true, IP: true, CFT: false },
  { title: 'Obstetricia y Puericultura', UNI: true, IP: false, CFT: false },
  { title: 'Odontología', UNI: true, IP: false, CFT: false },
  { title: 'Química y Farmacia', UNI: true, IP: false, CFT: false },
  { title: 'Técnico en Arsenalería', UNI: false, IP: true, CFT: false },
  { title: 'Técnico en Enfermería', UNI: true, IP: true, CFT: true },
  { title: 'Técnico en Estética', UNI: false, IP: true, CFT: true },
  { title: 'Técnico en Farmacia', UNI: false, IP: true, CFT: true },
  {
    title: 'Técnico en Medicinas Alternativas',
    UNI: false,
    IP: true,
    CFT: true
  },
  { title: 'Técnico en Nutrición', UNI: false, IP: true, CFT: true },
  {
    title: 'Técnico en Obstetricia y Puericultura',
    UNI: false,
    IP: false,
    CFT: true
  },
  {
    title: 'Técnico en Odontología y Asistente Dental',
    UNI: true,
    IP: true,
    CFT: true
  },
  { title: 'Técnico en Óptica', UNI: false, IP: false, CFT: true },
  { title: 'Técnico en Peluquería', UNI: false, IP: true, CFT: true },
  { title: 'Técnico en Podología', UNI: false, IP: true, CFT: true },
  { title: 'Técnico en Radioterapia', UNI: false, IP: true, CFT: true },
  { title: 'Técnico Laboratorista Clínico', UNI: true, IP: true, CFT: true },
  { title: 'Tecnología Médica', UNI: true, IP: false, CFT: false },
  { title: 'Terapia Ocupacional', UNI: true, IP: true, CFT: false }
];

const tableTecnologia = [
  { title: 'Construcción Civil', UNI: true, IP: true, CFT: false },
  {
    title:
      'Ingenierías I (Matemática; Bioingeniería; Biotecnología; Climatización y Refrigeración; Administración de Operaciones; Gestión de Calidad)',
    UNI: true,
    IP: false,
    CFT: false
  },
  {
    title:
      'Ingenierías II (Eléctrica; Electrónica; Construcción; Geomensura; Minas; Metalurgia; Mecánica; Mantenimiento Industrial; Ejecución Industrial; Ambiental; Prevención de Riesgos; Logística; Automatización y Control Industrial)',
    UNI: true,
    IP: true,
    CFT: false
  },
  {
    title:
      'Ingenierías III (Computación e Informática; Telecomunicaciones; Sonido; Procesos Industriales; Transporte Marítimo y Aéreo; Alimentos)',
    UNI: true,
    IP: true,
    CFT: false
  },
  {
    title:
      'Ingenierías IV (Conectividad y Redes; Seguridad; Mecánica Automotriz)',
    UNI: false,
    IP: true,
    CFT: false
  },
  {
    title:
      'Ingeniería Civil I (Plan Común; Química; Biomédica; Bioquímica; Biotecnología; Eléctrica; Electrónica; Acústica; Aeroespacial; Automatización; Telecomunicaciones; Conectividad y Redes)',
    UNI: true,
    IP: false,
    CFT: false
  },
  {
    title:
      'Ingeniería Civil II (Industrial; Mecánica; Matemática; Química; Construcción; Geografía; Geomática; Geológica; Metalurgia; Minas; Obras Civiles; Transporte; Prevención de Riesgos)',
    UNI: true,
    IP: false,
    CFT: false
  },
  {
    title:
      'Ingeniería Civil III (Computación y/o Informática; Ambiental; Energía y Medioambiente)',
    UNI: true,
    IP: true,
    CFT: false
  },
  {
    title:
      'Técnicos I (Computación e Informática; Administración de Redes Computacionales; Programador Computacional; Análisis de Sistemas Informáticos; Automatización y Control automático)',
    UNI: true,
    IP: true,
    CFT: true
  },
  {
    title:
      'Técnicos II (Construcción; Metalurgia; Minas; Electricidad y Electrónica; Energías Renovables; Mecánica Industrial y mantención; Logística; Topografía; Transporte; Alimentos)',
    UNI: true,
    IP: true,
    CFT: true
  },
  {
    title:
      'Técnicos III (Mecánica Automotriz; Medio Ambiente; Operaciones Industriales; Prevención de Riesgos)',
    UNI: true,
    IP: true,
    CFT: true
  },
  { title: 'Informática Biomédica', UNI: false, IP: true, CFT: false },
  { title: 'Técnico en Biotecnología', UNI: true, IP: false, CFT: true },
  { title: 'Técnico en Control de Calidad', UNI: false, IP: true, CFT: true },
  { title: 'Técnico en Geología', UNI: false, IP: true, CFT: true },
  { title: 'Técnico en Obras Civiles', UNI: true, IP: false, CFT: true },
  {
    title: 'Técnico en Refrigeración y Climatización',
    UNI: true,
    IP: false,
    CFT: true
  },
  { title: 'Técnico en Seguridad', UNI: false, IP: false, CFT: true },
  { title: 'Técnico en Sonido', UNI: false, IP: true, CFT: false },
  { title: 'Técnico en Telecomunicaciones', UNI: true, IP: true, CFT: false },
  {
    title: 'Técnico Instrumentación Industrial',
    UNI: true,
    IP: false,
    CFT: true
  }
];
// { title: '', UNI: false, IP: false, CFT: false },
